/**
 * 定义路径s
 */
const PATH = 'user_'
/*
包含n个mutation的type名称常量
 */
export const USER_LOGIN = PATH + 'login'
export const USER_LOGOUT = PATH + 'logout'
export const USER_INFO = PATH + 'info'



// WEBPACK FOOTER //
// ./src/store/mutations/user/type.js